/* eslint-disable @typescript-eslint/no-explicit-any */
import { HTTPInstanceFastApiWithPrefix } from '@/lib/http/http-instance-fastapi-with-prefix'

class ChatBotAPI {
  static postMessage = (message: string): Promise<any> =>
    HTTPInstanceFastApiWithPrefix.post('/query-instruction', {
      query: message
    }).then(response => response.data)
}

export default ChatBotAPI
